import React from "react";
import ReactDom from "react-dom";
import TypeaheadSearch from "./TypeaheadSearch.jsx";

export default function renderTypeaheadSearch() {
  document.querySelectorAll(".js-typeahead").forEach((mount) => {
    const dataModel = JSON.parse(mount.dataset.model);
    ReactDom.render(
      <TypeaheadSearch
        showSearchIcon={true}
        className="js-typeahead"
        {...dataModel}
      />,
      mount,
    );
  });
}
